module.exports = __webpack_public_path__ + "img/list_icon.3f6d57fd.svg";